import React, { useEffect, useState, useMemo } from "react";
import client from "../../graphQl/graphqlClient";
import { gql } from "graphql-tag";
import { categoryValues } from "./category.json";
import { GooeyCircleLoader } from "react-loaders-kit";
import Typed from "react-typed";
//import Modal from "react-modal";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import config from "../../config";
import Head from "next/head";
import { useRouter } from "next/router";
import {
  addItemInCompareList,
  createCompareList,
  getLocationDetail,
} from "../../api.services.js/catalouge";
import swal from "sweetalert";
import $ from "jquery";
import { savePincode, urlResolver } from "../../api.services.js/others";
import Loader from "../../src/components/loader";
import ProductCard from "../../src/productCard";
import { parse } from "cookie";
import cookie from "js-cookie";
import { getIntouch } from "../../api.services.js/others";
import Form from "react-bootstrap/Form";
import axios from "axios";
import UnbxdProductCard from "../../src/UnbxdProductCard";
import attributejson from "../../attributes.json";
// const { JSDOM } = require('jsdom');
const getProductQueryServerSide = gql`
  query Products(
    $filter: ProductAttributeFilterInput!
    $sort: ProductAttributeSortInput!
    $pageSize: Int!
    $currentPage: Int!
  ) {
    products(
      filter: $filter
      sort: $sort
      pageSize: $pageSize
      currentPage: $currentPage
    ) {
      currentcategory {
        name
        description
        dynamic_content
        imageUrl
        meta_keywords
        meta_description
        meta_title
        schema
        videoschema
        breadcrumbs {
          category_id
          category_name
          category_level
          category_url_key
          category_url_path
        }
      }
      appliedFilters {
        label
        value
        attribute_code
      }
      aggregations(filter: { category: { includeDirectChildrenOnly: true } }) {
        attribute_code
        count
        label
        options {
          label
          value
          count
          swatch_data {
            type
            value
          }
        }
      }
      subcategories {
        id
        name
        imageUrl
      }
      total_count
      items {
        id
        name
        sku
        url_key
        price_range {
          minimum_price {
            regular_price {
              value
              currency
            }
            final_price {
              value
              currency
            }
            discount {
              amount_off
              percent_off
            }
          }
          maximum_price {
            regular_price {
              value
              currency
            }
            final_price {
              value
              currency
            }
            discount {
              amount_off
              percent_off
            }
          }
        }
        extraVariables {
          skd_stock
          dora_stock
          hoskote_stock
          west_zone_stock
          tile_type
          tile_area
          factory
          finish {
            label
            value
            url_key
          }
          tile_design
          is_enabled
          is_new
          image_url
          ambience_image_url
          product_url
          tile_size
          sq_ft_price
        }
      }
      total_count
      sort_fields {
        default
        options {
          value
          label
        }
      }
    }
  }
`;

export const getServerSideProps = async (context) => {
  try {
    const cookies = parse(context.req.headers.cookie || "");
    let value = "95";
    if (context.query.tile_type) {
      value = context.query.tile_type;
    }
    let categoryValue = "tiles";
    let fitterrss = { category_id: { in: [value] } };
    let fitterrss2 = {};
    let errorArray = [
      "cat",
      "remc",
      "product_list_order",
      "product_list_dir",
      "mt",
      "trending",
      "tile_finish",
      "aor",
      "tiles_design",
      "tile_color",
      "p",
      "locations",
      ";popularity",
      "application",
      "type_finish",
      "plocation",
      ";trending",
      ";mt",
      "tiles_type",
      "finish",
      "limit",
      "available_region",
    ];

    let filterArray = [
      "colors",
      "istiles",
      "plocation",
      "popularity",
      "price",
      "recommended",
      "tiles_finish",
      "tile_area",
      "tile_category",
      "tile_collections",
      "tile_design",
      "tile_factory_production",
      "tile_size",
      "tile_type",
    ];
    for (let f of Object.keys(context.query)) {
      if (f && context.query[f]) {
        if (
          f != "category" &&
          !isNaN(context.query[f].split(",")[0]) &&
          !errorArray.includes(f)
        ) {
          fitterrss = {
            ...fitterrss,
            [f]: { in: context.query[f].split(",").map((cur) => Number(cur)) },
          };
          fitterrss2 = {
            ...fitterrss2,
            [f]: { $in: context.query[f].split(",").map((cur) => Number(cur)) },
          };
        }
      }
    }
    let locationDetail;
    let ProdBySalesDate = [];
    let UnbxdProd = [];
    let facetsUnbxd = null; // Ensure it's initialized to null
    let appliedFilterFromUnbxd = [];
    if (cookies?.pincode) {
      locationDetail = await getLocationDetail({ pincode: cookies?.pincode });
      let respp = await axios.post(
        `https://proxy.orientbell.com/api/products?category=${value}&pincode=${cookies.pincode}`,
        fitterrss2
      );
      ProdBySalesDate = respp.data;
      if (locationDetail?.data?.p_location) {
        fitterrss = {
          ...fitterrss,
          plocation: { in: [locationDetail?.data?.p_location.value] },
        };
      }
    } else if (!cookies?.pincode) {
      const queryParamsArray = Object.keys(context.query)

        .filter((key) => key !== "category") // Exclude 'category'
        .map((key) => ({
          [key]: isNaN(context.query[key])
            ? context.query[key]
            : Number(context.query[key]), // Convert numeric values to numbers
        }));

      if (queryParamsArray.length == 0) {
        UnbxdProd = await axios.get(
          `https://search.unbxd.io/5a4b9251b67027ff94d260e4ac6ac09e/ss-unbxd-aapac-prod-orientbell53741713874410/category?p-id=categoryPathId%3A%22${encodeURIComponent(
            context.resolvedUrl
          )}%22&facet.multiselect=true&spellcheck=true&pagetype=boolean&facet.multiselect=true&spellcheck=true&rows=25&start=0&version=V2&fallback=true&viewType=GRID&facet.version=V2`
        );
      } else if (queryParamsArray.length > 0) {
        let tempUrl = context.resolvedUrl.split("?")[0];

        UnbxdProd = await axios.get(
          `https://search.unbxd.io/5a4b9251b67027ff94d260e4ac6ac09e/ss-unbxd-aapac-prod-orientbell53741713874410/category?p-id=categoryPathId%3A%22${encodeURIComponent(
            tempUrl
          )}%22&facet.multiselect=true&spellcheck=true&pagetype=boolean&facet.multiselect=true&spellcheck=true&rows=25&start=0&version=V2&fallback=true&viewType=GRID&facet.version=V2`
        );
      }
      facetsUnbxd = UnbxdProd.data.facets || null;
      appliedFilterFromUnbxd = queryParamsArray || null;
    }
    const { data } = await client.query({
      query: getProductQueryServerSide,
      variables: {
        filter: fitterrss,
        sort: { recommended: "ASC" },
        pageSize: cookies?.pincode ? 1 : 15,
        currentPage: 1,
      },
    });
    //   if(data?.products?.items?.length == 0 && !data?.currentcategory && !cookies?.pincode){
    //   return {
    //     redirect: {
    //       destination: `/404`,
    //       permanent: false,
    //     }
    //   }
    // }
    return {
      props: {
        data,
        value,
        categoryValue,
        regionData: locationDetail?.data?.p_location
          ? locationDetail?.data?.p_location
          : null,
        videoSchema: data?.products?.currentcategory?.videoschema,
        fitterrss,
        ProdBySalesDate,
        fitterrss2,
        displayLocationPopop: true,
        UnbxdResponse: UnbxdProd?.data?.response
          ? UnbxdProd?.data?.response
          : [],
        facetsUnbxd, // Now it's either an object, array, or null
        appliedFilterFromUnbxd,
      },
    };
  } catch (error) {
    return {
      redirect: {
        destination: `/404`,
        permanent: false,
      },
    };
  }
};
const Category = (data) => {
  let router = useRouter();
  const [ProdBySalesDate, setProdBySalesDate] = useState(data.ProdBySalesDate);
  const [PageSalesSize, setPageSalesSize] = useState(25);
  const [fitterrss2, setfitterrss2] = useState(data.fitterrss2);
  const [dataSet, setDataSet] = useState(data.data.products);
  const [filterData, setFilterData] = useState(data.data.products.aggregations);
  const [selectedFilterData, setSelectedFilterData] = useState();
  const [filterTypeDataSet, setFilterTypeDataSet] = useState();
  const [isParamChange, setIsParamChange] = useState(false);
  const [relatedBlogData, setRelatedBlogData] = useState([]);
  const [sortValue, setSortValue] = useState(
    data.data.products.sort_fields.default
  );
  const [selectedCode, setSelectedCode] = useState("");
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [isFilterselected, setIsFilterselected] = useState(false);
  const [openFilterFlag, setOpenFilterFlag] = useState(false);
  const [isAmbience, setIsAmbience] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [shortDiscription, setShortDiscription] = useState(
    data.data.products.currentcategory?.description
  );
  const [getInTouch, setGetInTouch] = useState(false);
  const [filteractive, setFilterActive] = useState("");
  const [mobileFilterOpen, setmobileFilterOpen] = useState(false);
  const [touch, setTouch] = useState({
    name: "",
    number: "",
    pincode: cookie.get("pincode"),
    error: "",
    loading: false,
  });

  const [pageLayoutClass, setPageLayoutlass] = useState(
    "product-listing-Three obl-pro-list-row"
  );
  const [filterSet, setFilterSet] = useState({
    filter: { category_id: { in: [data.value] } },
    sort: { recommended: "ASC" },
    pageSize: 25,
    currentPage: 1,
  });
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [pincode, setPinCode] = useState(undefined);
  const [UnbxdPdts, setUnbxdPdts] = useState(data.UnbxdResponse.products);
  const [totalPdtsFromUnbxd, setTotalPdtsFromUnbxd] = useState(
    data.UnbxdResponse.numberOfProducts
  );
  let pageSizeUnbxd = data?.UnbxdResponse?.products?.length;
  const [defaultFacets, setDefaultFacets] = useState(
    data?.facetsUnbxd?.text?.list
  );

  const [selectedFilterFromUnbxd, setSelectedFilterFromUnbxd] = useState([]);
  const [noOfFilteredPdtFromUnbxd, setNoOfFilteredPdtFromUnbxd] = useState("");

  const totalProducts = useMemo(() => {
    return selectedFilterFromUnbxd.length > 1
      ? noOfFilteredPdtFromUnbxd
      : data.UnbxdResponse.numberOfProducts;
  }, [
    selectedFilterFromUnbxd,
    noOfFilteredPdtFromUnbxd,
    data.UnbxdResponse.numberOfProducts,
  ]);

  const filterMapArr = [
    {
      tileType_uFilter: "tile_type",
      tileSize_uFilter: "tile_size",
      tilesFinish_uFilter: "tiles_finish",
      colors_uFilter: "colors",
      tileCollections_uFilter: "tile_collections",
      tileFactoryProduction_uFilter: "tile_factory_production",
      tileDesign_uFilter: "tile_design",
      tileCategory_uFilter: "tile_category",
      tileArea_uFilter: "tile_area",
    },
  ];
  const [showClearAll, setShowClearAll] = useState(false);
  useEffect(() => {
    window.UnbxdAnalyticsConf = window.UnbxdAnalyticsConf || {};
    window.UnbxdAnalyticsConf["page"] = router?.asPath?.split("?")[0];
    window.UnbxdAnalyticsConf["page_type"] = "BOOLEAN";
    setLoading(false);
    setLoading(false);
    setDataSet(data.data.products);
    setProdBySalesDate(data.ProdBySalesDate);
    setfitterrss2(data.fitterrss2);
    setFilterData(data.data.products.aggregations);
    // if(data.data.products.currentcategory?.description){
    //   appendBaseUrlToSrc(data.data.products.currentcategory.description)
    // }
  }, [router]);
  useEffect(() => {
    if (data.data.products.currentcategory?.description) {
      appendBaseUrlToSrc(data.data.products.currentcategory.description);
    }
    $(".toggle").click(function (e) {
      e.preventDefault();

      var $this = $(this);

      if ($this.next().hasClass("show")) {
        $this.next().removeClass("show");
        $this.next().slideUp(350);
      } else {
        $this.parent().parent().find("li .inner").removeClass("show");
        $this.parent().parent().find("li .inner").slideUp(350);
        $this.next().toggleClass("show");
      }
    });

    var requestOptions = {
      method: "GET",
    };

    const tempFilterTypeArray = [];
    filterData.forEach((obj) => {
      if (obj.attribute_code == "tile_category") {
        tempFilterTypeArray.push("Floor");
      } else if (
        obj.attribute_code !== "price" &&
        obj.attribute_code !== "istiles" &&
        obj.attribute_code !== "plocation" &&
        obj.attribute_code !== "category_id" &&
        obj.attribute_code !== "recommended" &&
        obj.attribute_code !== "popularity" &&
        obj.attribute_code !== "available_region_bucket"
      ) {
        tempFilterTypeArray.push(obj.label);
      }
    });
    setFilterTypeDataSet(tempFilterTypeArray);
    onFilterOnClickButton(tempFilterTypeArray[0]);
    const selectedFilterFromLocalStorage =
      localStorage.getItem("selectedFilter");
    const pin = cookie.get("pincode");
    setPinCode(pin);
    fetch(
      `${config.HEADLESS_BASE_URL}/blog/wp-json/post/v2/category/term=${data.categoryValue}`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        setRelatedBlogData(JSON.parse(result));
      })
      .catch((error) => console.log("error", error));
    if (selectedFilterFromLocalStorage) {
      // const finalResult = JSON.parse(selectedFilterFromLocalStorage);
      // const selFilt = {
      //   key: finalResult.key,
      //   value: finalResult.value,
      //   code: finalResult.code,
      // };
      // selectedFilters.push(selFilt);
      // setSelectedFilters(selectedFilters);
      // setIsFilterselected(true);
      // setPinCode(pin);
    } else {
      // setPinCode(undefined);
      setTimeout(() => {
        // if(!localStorage.getItem('pincodeSkip')){
        //   setModalIsOpen(true);
        // }
      }, 5000);
    }
  }, [router]);
  let loadMoreSalesData = async () => {
    setLoading2(true);
    let respp = await axios.post(
      `https://proxy.orientbell.com/api/products?category=${
        data.value
      }&pincode=${cookie.get("pincode")}&size=${PageSalesSize + 25}`,
      fitterrss2
    );
    setPageSalesSize(PageSalesSize + 25);
    setProdBySalesDate(respp.data);
    setLoading2(false);
  };
  const loadMoreSalesData2 = async () => {
    setLoading2(true);
    try {
      const pageSize = 25;
      const currentCount = UnbxdPdts.length;

      // Start building the URL
      const unbxdUrl = new URL(
        `https://search.unbxd.io/5a4b9251b67027ff94d260e4ac6ac09e/ss-unbxd-aapac-prod-orientbell53741713874410/category`
      );

      unbxdUrl.searchParams.append(
        "p-id",
        `categoryPathId:"${decodeURIComponent(router.asPath?.split("?")[0])}"`
      );
      unbxdUrl.searchParams.append("facet.multiselect", "true");
      unbxdUrl.searchParams.append("spellcheck", "true");
      unbxdUrl.searchParams.append("pagetype", "boolean");
      unbxdUrl.searchParams.append("start", `${currentCount}`);
      unbxdUrl.searchParams.append("rows", `${pageSize}`);
      unbxdUrl.searchParams.append("version", "V2");
      unbxdUrl.searchParams.append("fallback", "true");
      unbxdUrl.searchParams.append("viewType", "GRID");
      unbxdUrl.searchParams.append("facet.version", "V2");

      // ✅ Append selected filters from state
      selectedFilterFromUnbxd.forEach(({ facetName, facetValue }) => {
        unbxdUrl.searchParams.append("filter", `${facetName}:"${facetValue}"`);
      });

      const response = await axios.get(unbxdUrl.toString(), {
        headers: {
          "unbxd-user-id": cookie.get("unbxd.userId"),
        },
      });

      const newProducts = response.data.response.products || [];

      if (newProducts.length > 0) {
        setUnbxdPdts((prevPdts) => [...prevPdts, ...newProducts]);
      }

      setTotalPdtsFromUnbxd(response.data.response.numberOfProducts);
    } catch (error) {
      console.error("Error loading more products:", error);
    }

    setLoading2(false);
  };

  useEffect(() => {
    if (isParamChange) {
      $(".main-sidebar").removeClass("open-filter");
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      let filterrrr = filterSet.filter;
      if (data.regionData) {
        filterrrr = {
          ...filterrrr,
          plocation: { in: [data.regionData.value] },
        };
      }
      var graphql = JSON.stringify({
        variables: {
          filter: data.fitterrss,
          sort: filterSet.sort,
          pageSize: filterSet.pageSize,
          currentPage: filterSet.currentPage,
        },
        query: getProductQuery,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: graphql,
        redirect: "follow",
      };
      fetch("https://proxy.orientbell.com", requestOptions)
        .then((response) => response.text())
        .then((result) => {
          const finalResult = JSON.parse(result);
          setDataSet(finalResult.data.products);
          appendBaseUrlToSrc(
            finalResult.data.products.currentcategory.description
          );
          setFilterData(finalResult.data.products.aggregations);
          const tempFilterTypeArray = [];
          finalResult.data.products.aggregations.forEach((obj) => {
            if (obj.attribute_code == "tile_category") {
              tempFilterTypeArray.push("Floor");
            } else if (
              obj.attribute_code !== "price" &&
              obj.attribute_code !== "istiles" &&
              obj.attribute_code !== "plocation" &&
              obj.attribute_code !== "category_id" &&
              obj.attribute_code !== "recommended" &&
              obj.attribute_code !== "popularity" &&
              obj.attribute_code !== "available_region_bucket"
            ) {
              tempFilterTypeArray.push(obj.label);
            }
          });
          setFilterTypeDataSet(tempFilterTypeArray);

          setOpenFilterFlag(true);
          setIsParamChange(false);
          setLoading(false);
          setLoading2(false);
        })
        .catch((error) => console.log("error", error));
    }
  }, [filterSet, isParamChange, data.appliedFilterFromUnbxd]);

  useEffect(() => {
    if (isFilterselected) {
      let createFilterDtoSet = {
        category_id: { in: [data.value] },
      };
      selectedFilters.forEach((obj) => {
        if (obj.code in createFilterDtoSet) {
          const arrayValue = createFilterDtoSet[obj.code].in;
          if (!arrayValue.includes(obj.key)) {
            arrayValue.push(obj.key);
          }
          createFilterDtoSet[obj.code].in = arrayValue;
        } else {
          const newFilterSet = {
            [obj.code]: { in: [obj.key] },
          };
          createFilterDtoSet = {
            ...createFilterDtoSet,
            ...newFilterSet,
          };
        }
      });
      setFilterSet({
        ...filterSet,
        filter: createFilterDtoSet,
      });
      setLoading(true);
      setIsParamChange(true);
      setIsFilterselected(false);
    }
  }, [selectedFilters, isFilterselected]);

  useEffect(() => {
    if (openFilterFlag) {
      onFilterOnClickButton(filterTypeDataSet[0]);
      setOpenFilterFlag(false);
    }
  }, [filterData]);

  const getProductQuery = `query Products ($filter: ProductAttributeFilterInput!, $sort: ProductAttributeSortInput!, $pageSize: Int!, $currentPage: Int!){
      products(
          filter: $filter,
          sort: $sort,
          pageSize: $pageSize,
          currentPage: $currentPage
      ) {
      currentcategory{
          name
          description
          dynamic_content
          imageUrl
          meta_keywords
          meta_description
          meta_title
          schema
          breadcrumbs{
            category_id
            category_name
            category_level
            category_url_key
            category_url_path
        }
      }
      appliedFilters{
        label
        value
        attribute_code
    }
      aggregations(filter: { category: {includeDirectChildrenOnly: true}}) {
          attribute_code
          count
          label
          options {
              label
              value
              count
              swatch_data {
                  type
                  value
              }
          }
      }
      subcategories{
          id
          name
          imageUrl
      }
      total_count
      items {
          id
          name
          sku
          url_key
          price_range {
          minimum_price {
              regular_price {
              value
              currency
              }
              final_price {
              value
              currency
              }
              discount {
              amount_off
              percent_off
              }
          }
          maximum_price {
              regular_price {
              value
              currency
              }
              final_price {
              value
              currency
              }
              discount {
              amount_off
              percent_off
              }
          }
          }
          extraVariables{
            skd_stock
				     dora_stock
				     hoskote_stock
				     west_zone_stock
              is_enabled
              is_new
              image_url
              ambience_image_url
              product_url
              tile_size
              sq_ft_price
          }
      }
      total_count
      sort_fields{
          default
          options {
          value
          label
          }
      }
      }
    }`;

  const getPloaction = `query P_location($pincode: Int!){
    p_location(pincode : $pincode){
      pincode
      attribute_name
      state
      value
    }
  }`;

  const onFilterOnClickButton = (value) => {
    const filterValuesArray = [];
    if (value == "Floor") {
      filterData.forEach((obj) => {
        if (obj.label == "Tile Category") {
          setSelectedCode(obj.attribute_code);
          obj.options.forEach((val) => {
            const tempFilterDataSet = {
              key: val.value,
              value: val.label,
            };
            if (tempFilterDataSet.key != tempFilterDataSet.value) {
              filterValuesArray.push(tempFilterDataSet);
            }
          });
        }
      });
    } else {
      filterData.forEach((obj) => {
        if (obj.label == value) {
          setSelectedCode(obj.attribute_code);
          obj.options.forEach((val) => {
            const tempFilterDataSet = {
              key: val.value,
              value: val.label,
            };
            if (tempFilterDataSet.key != tempFilterDataSet.value) {
              filterValuesArray.push(tempFilterDataSet);
            }
          });
        }
      });
    }
    setSelectedFilterData(filterValuesArray);
  };

  const handleSortChange = (e) => {
    setSortValue(e.target?.value);
    const newSort = {
      [e.target?.value]: "ASC",
    };
    setFilterSet({
      ...filterSet,
      sort: newSort,
    });
    setLoading(true);
    setIsParamChange(true);
  };

  const onFilterClick = (e, title) => {
    setmobileFilterOpen(false);
    setLoading(true);
    let queryObj = router.query;
    queryObj[selectedCode] = e;
    delete queryObj["category"];
    router.replace({
      pathname: `/tiles`,
      query: queryObj,
    });
    return;
    const selFilt = {
      key: e,
      value: title,
      code: selectedCode,
    };
    selectedFilters.push(selFilt);
    setSelectedFilters(selectedFilters);
    setIsFilterselected(true);
  };

  const handleRemove = (input) => {
    setLoading(true);
    let queryObj = router.query;
    if (queryObj[input.attribute_code].split(",").length == 1) {
      delete queryObj[input.attribute_code];
    } else {
      queryObj[input.attribute_code] = queryObj[input.attribute_code]
        .split(",")
        .filter((cc) => cc != input.value)
        .join(",");
    }
    delete queryObj["category"];
    router.replace({
      pathname: `/tiles`,
      query: queryObj,
    });

    return;
    let toRemoveFilter = selectedFilters;
    toRemoveFilter = toRemoveFilter.filter((item) => item !== input);
    setSelectedFilters(toRemoveFilter);
    setIsFilterselected(true);
    if (input.code == "plocation") {
      localStorage.removeItem("selectedFilter");
      setPinCode("");
    }
  };
  const handleClick = () => {
    const cleanUrl = window.location.pathname; // Get only the path without query params
    router.replace(cleanUrl, undefined, { shallow: true }); // Update URL without reloading
    setTimeout(() => {
      handleRemove2();
    }, 100); // Slight delay to ensure URL updates before reloading the page
  };

  const handleRemove2 = () => {
    setLoading(true);
    cookie.remove("pincode");
    localStorage.removeItem("pincode");
    cookie.set("removelocation", true, { expires: 7 });
    router.reload();
  };
  const removeAllFilters = () => {
    handleRemove2();
    router.replace({
      pathname: `/tiles`,
    });
    return;
    setFilterSet({
      ...filterSet,
      filter: { category_id: { in: [data.value] } },
    });
    setLoading(true);
    setIsParamChange(true);
    setSelectedFilters([]);
    localStorage.removeItem("selectedFilter");
    setPinCode("");
  };

  const handleAmbience = (e) => {
    setIsAmbience(e.target.checked);
  };

  const LoadFunction = () => {
    const loaderProps = {
      loading: true,
      size: 275,
      duration: 2,
      colors: ["#99fffe", "#f42e00", "#042549"],
    };

    return (
      <div className="loader">
        <GooeyCircleLoader {...loaderProps} />
        <Typed
          className="loader-text"
          strings={["Loading..."]}
          typeSpeed={60}
          backSpeed={0}
        />
      </div>
    );
  };

  const handleLayOutclass = (type) => {
    if (type == "one") {
      setPageLayoutlass("product-listing-Three obl-pro-list-row");
    } else if (type == "two") {
      setPageLayoutlass("product-listing-Two obl-pro-list-row");
    } else if (type == "three") {
      setPageLayoutlass("product-listing-One obl-pro-list-row");
    }
  };

  const handlePinCodeChange = (e) => {
    setPinCode(e.target.value);
  };

  const handlePinCodeChangeInput = (e) => {
    setPinCode(e.target.value);
    const pincode = e.target.value * 1;
    if (e.target.value.length == 6) {
      setLoading(true);
      savePincode({ pincodedetails: pincode });
      cookie.set("pincode", pincode, { expires: 7 });
      localStorage.setItem("pincode", pincode);
      localStorage.setItem("pincodeSkip", true);
      if (ProdBySalesDate?.data?.length > 0) {
        setShowClearAll("node");
      } else {
        setShowClearAll("unbxd");
      }

      router.reload();
      return;
      setLoading(true);
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      var graphql = JSON.stringify({
        query: getPloaction,
        variables: { pincode },
      });
      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: graphql,
        redirect: "follow",
      };

      fetch("https://proxy.orientbell.com", requestOptions)
        .then((response) => response.text())
        .then((result) => {
          let filterArray = selectedFilters;
          if (selectedFilters.length > 0) {
            localStorage.removeItem("selectedFilter");
            localStorage.removeItem("pincode");
            filterArray = filterArray.filter(
              (item) => item.code !== "plocation"
            );
          }
          const finalResult = JSON.parse(result);
          const selFilt = {
            key: finalResult.data.p_location.value,
            value: finalResult.data.p_location.state,
            code: finalResult.data.p_location.attribute_name,
          };
          filterArray.push(selFilt);
          setSelectedFilters(filterArray);
          setIsFilterselected(true);
          setModalIsOpen(false);
          localStorage.setItem("selectedFilter", JSON.stringify(selFilt));
          localStorage.setItem("pincode", pincode);
          cookie.set("pincode", pincode, { expires: 7 });
        })
        .catch((error) => console.log("error", error));
    }
  };

  const handlePinSave = () => {
    if (pincode.length == 6) {
      setModalIsOpen(false);
      localStorage.setItem("pincodeSkip", true);
      setLoading(true);
      savePincode({ pincodedetails: pincode });
      cookie.set("pincode", pincode, { expires: 7 });
      localStorage.setItem("pincode", pincode);
      router.reload();
      return;
      setLoading(true);
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      var graphql = JSON.stringify({
        query: getPloaction,
        variables: { pincode },
      });
      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: graphql,
        redirect: "follow",
      };

      fetch("https://proxy.orientbell.com", requestOptions)
        .then((response) => response.text())
        .then((result) => {
          const finalResult = JSON.parse(result);
          const selFilt = {
            key: finalResult.data.p_location.value,
            value: finalResult.data.p_location.state,
            code: finalResult.data.p_location.attribute_name,
          };
          selectedFilters.push(selFilt);
          setSelectedFilters(selectedFilters);
          setIsFilterselected(true);
          setModalIsOpen(false);
          localStorage.setItem("selectedFilter", JSON.stringify(selFilt));
          localStorage.setItem("pincode", pincode);
        })
        .catch((error) => console.log("error", error));
    } else {
      alert("Invalid Pin Code");
    }
  };
  const addProductToComapre = async (id) => {
    if (localStorage.getItem("compareListUid")) {
      let addProduct = await addItemInCompareList({
        compareListUid: localStorage.getItem("compareListUid"),
        productIds: [String(id)],
      });

      if (addProduct?.message) {
        swal(addProduct.message);
        return;
      }

      swal({
        title: "Item added",
        text: `You have ${addProduct.data.addProductsToCompareList.item_count} in your compare list`,
        icon: "success",
        buttons: ["Cancel", "Compare"],
      }).then((result) => {
        if (result) {
          router.push("/catalog/product_compare");
        }
      });
    } else {
      let createList = await createCompareList({ productIds: [String(id)] });
      if (createList.message) {
        swal(createList.message);
      } else {
        localStorage.setItem(
          "compareListUid",
          createList.data.createCompareList.uid
        );
        swal("Iteam added in you compare list and more items to compare");
      }
    }
  };
  const appendBaseUrlToSrc = (htmlContent) => {
    const tempElement = document.createElement("div");
    tempElement.innerHTML = htmlContent.replace(/<p>\s*<\/p>/g, "");
    const imgElements = tempElement.querySelectorAll("img");
    imgElements.forEach((img) => {
      const src = img.getAttribute("src");
      if (src && (!src.startsWith("http") || !src.startsWith("https"))) {
        img.setAttribute("src", config.API_ENDPOINT + "/" + src);
      } else {
        img.setAttribute("src", "/" + src);
      }
    });

    setShortDiscription(tempElement.innerHTML);
  };
  const submitGetInTouch = async () => {
    const namee = touch.name;
    const no = touch.number;
    const pin = touch.pincode;

    if (!namee || !no || !pin) {
      setTouch({
        ...touch,
        error: "All fields are required",
      });
    } else if (String(pin).length != 6) {
      setTouch({
        ...touch,
        error: "Invalid Pincode",
      });
    } else {
      setTouch({
        ...touch,
        error: "",
        loading: true,
      });
      let response = await getIntouch({
        name: namee,
        phone: no,
        pincode: pin,
      });
      if (response?.message) {
        localStorage.setItem("leadfilled", true);
        swal(response?.message);
        setTouch({
          ...touch,
          error: "",
          loading: false,
        });
      } else {
        swal(response.data.get_in_touch.msg);
        setGetInTouch(false);
        setTouch({
          name: "",
          number: "",
          error: "",
          loading: false,
        });
      }
    }
  };
  const breadsCrumbSchema = () => {
    return {
      __html: `{
        "@context": "https://schema.org/", 
        "@type": "BreadcrumbList", 
        "itemListElement": [{
          "@type": "ListItem", 
          "position": 1, 
          "name": "Home",
          "item": "https://www.orientbell.com"
        },{
          "@type": "ListItem", 
          "position": 2, 
          "name": "Tiles",
          "item": "https://www.orientbell.com/tiles"  
        },{
         "@type": "ListItem", 
         "position": 3, 
         "name": "${dataSet.currentcategory.name}",
         "item": "${router.asPath}"  
       }
      ]
      }`,
    };
  };
  const webPageSchema = () => {
    return {
      __html: `{
        "@context": "https://schema.org",
        "@type": "WebPage",
        "url": "${router.asPath}",
        "headline": "",
        "breadcrumb": "Home > Tiles > ${
          dataSet.currentcategory?.breadcrumbs
            ? dataSet.currentcategory?.breadcrumbs[1]?.category_name
            : ""
        }",
        "name": "${dataSet?.currentcategory?.meta_title}",
        "description": "${dataSet?.currentcategory?.meta_description}"
      }`,
    };
  };
  const handleRemoveUnbxdFilter = (filterToRemove) => {
    setSelectedFilterFromUnbxd((prevFilters) => {
      // Remove the selected filter from state
      const updatedFilters = prevFilters.filter(
        (filter) =>
          !(
            filter.facetName === filterToRemove.facetName &&
            filter.facetValue === filterToRemove.facetValue
          )
      );

      // Update URL query params after removing the filter
      const urlObj = new URL(window.location.href);

      // Get the transformed filter name and value
      const { transformedName, transformedValue } = transformFilter(
        filterToRemove.facetName,
        filterToRemove.facetValue
      );

      // Remove only the matching query parameter from URL
      urlObj.searchParams.delete(transformedName);

      // Update browser history without reloading
      window.history.pushState({}, "", urlObj.toString());

      // Construct the new Unbxd API URL
      const unbxdUrl = new URL(
        `https://search.unbxd.io/5a4b9251b67027ff94d260e4ac6ac09e/ss-unbxd-aapac-prod-orientbell53741713874410/category?p-id=categoryPathId%3A%22${encodeURIComponent(
          router.asPath.split("?")[0]
        )}%22`
      );

      // Add fixed parameters
      unbxdUrl.searchParams.append("facet.multiselect", "true");
      unbxdUrl.searchParams.append("spellcheck", "true");
      unbxdUrl.searchParams.append("pagetype", "boolean");
      unbxdUrl.searchParams.append("start", "0");
      unbxdUrl.searchParams.append("rows", `${pageSizeUnbxd + 25}`);
      unbxdUrl.searchParams.append("version", "V2");
      unbxdUrl.searchParams.append("fallback", "true");
      unbxdUrl.searchParams.append("viewType", "GRID");
      unbxdUrl.searchParams.append("facet.version", "V2");

      // Apply remaining filters to API request
      updatedFilters.forEach(({ facetName, facetValue }) => {
        unbxdUrl.searchParams.append("filter", `${facetName}:"${facetValue}"`);
      });

      // Make the API call
      (async () => {
        try {
          const response = await axios.get(unbxdUrl.toString(), {
            headers: {
              "unbxd-user-id": cookie.get("unbxd.userId"),
            },
          });

          // Update state with the response
          setUnbxdPdts(response.data.response.products);
          setNoOfFilteredPdtFromUnbxd(response.data.response.numberOfProducts);
        } catch (error) {
          console.log(error);
          swal(
            "Something went wrong while removing the filter, please try again."
          );
        }
      })();

      return updatedFilters;
    });
  };

  const removeUnbxdFilters = async () => {
    // Clear all filters from state
    setSelectedFilterFromUnbxd([]);

    // Remove all filters from URL
    const urlObj = new URL(window.location.href);
    urlObj.search = ""; // Clears query params
    window.history.pushState({}, "", urlObj.toString());

    // Construct API URL without filters
    const unbxdUrl = new URL(
      `https://search.unbxd.io/5a4b9251b67027ff94d260e4ac6ac09e/ss-unbxd-aapac-prod-orientbell53741713874410/category?p-id=categoryPathId%3A%22${encodeURIComponent(
        router.asPath.split("?")[0]
      )}%22`
    );

    // Add fixed parameters
    unbxdUrl.searchParams.append("facet.multiselect", "true");
    unbxdUrl.searchParams.append("spellcheck", "true");
    unbxdUrl.searchParams.append("pagetype", "boolean");
    unbxdUrl.searchParams.append("start", "0");
    unbxdUrl.searchParams.append("rows", "25");
    unbxdUrl.searchParams.append("version", "V2");
    unbxdUrl.searchParams.append("fallback", "true");
    unbxdUrl.searchParams.append("viewType", "GRID");
    unbxdUrl.searchParams.append("facet.version", "V2");

    try {
      const response = await axios.get(unbxdUrl.toString(), {
        headers: {
          "unbxd-user-id": cookie.get("unbxd.userId"),
        },
      });

      // Update state with unfiltered results
      setUnbxdPdts(response.data.response.products);
      setNoOfFilteredPdtFromUnbxd(response.data.response.numberOfProducts);
    } catch (error) {
      console.log(error);
      swal("Something went wrong while removing filters, please try again.");
    }
  };

  const transformFilter = (facetName, facetValue) => {
    // Get the transformed filter name
    const filterMapping = filterMapArr[0]; // Extracting from the array
    const transformedName = filterMapping[facetName] || facetName; // Default to original if no mapping

    // Get the transformed value
    const valueMapping = attributejson[transformedName]?.options || {}; // Fetch value mapping from JSON
    const transformedValue =
      Object.keys(valueMapping).find(
        (key) => valueMapping[key] === facetValue
      ) || facetValue; // Default to original if no match

    return { transformedName, transformedValue };
  };

  const filterResultsWithFacets = async (facetName, facetValue) => {
    setSelectedFilterFromUnbxd((prevFilters) => {
      const existingFilter = prevFilters.filter(
        (filter) => filter.facetName === facetName
      );
      let updatedFilters;

      if (existingFilter.length > 0) {
        updatedFilters = [
          ...prevFilters.filter((filter) => filter.facetName !== facetName),
          { facetName, facetValue },
        ];
      } else {
        updatedFilters = [...prevFilters, { facetName, facetValue }];
      }

      setmobileFilterOpen(false);

      // Update URL query params
      const urlObj = new URL(window.location.href);

      updatedFilters.forEach(({ facetName, facetValue }) => {
        const { transformedName, transformedValue } = transformFilter(
          facetName,
          facetValue
        );
        urlObj.searchParams.set(transformedName, transformedValue);
      });

      // Push updated URL without reloading
      window.history.pushState({}, "", urlObj.toString());

      console.log(router.asPath);

      // Unbxd API URL setup
      const unbxdUrl = new URL(
        `https://search.unbxd.io/5a4b9251b67027ff94d260e4ac6ac09e/ss-unbxd-aapac-prod-orientbell53741713874410/category?p-id=categoryPathId%3A%22${encodeURIComponent(
          router.asPath.split("?")[0]
        )}%22`
      );

      // Add query parameters
      unbxdUrl.searchParams.append("facet.multiselect", "true");
      unbxdUrl.searchParams.append("spellcheck", "true");
      unbxdUrl.searchParams.append("pagetype", "boolean");
      unbxdUrl.searchParams.append("start", "0");
      unbxdUrl.searchParams.append("rows", `${pageSizeUnbxd + 25}`);
      unbxdUrl.searchParams.append("version", "V2");
      unbxdUrl.searchParams.append("fallback", "true");
      unbxdUrl.searchParams.append("viewType", "GRID");
      unbxdUrl.searchParams.append("facet.version", "V2");

      // Apply transformed filters to API request
      updatedFilters.forEach(({ facetName, facetValue }) => {
        const { transformedName, transformedValue } = transformFilter(
          facetName,
          facetValue
        );
        unbxdUrl.searchParams.append("filter", `${facetName}:"${facetValue}"`);
      });

      // Make the API call
      (async () => {
        try {
          const response = await axios.get(unbxdUrl.toString(), {
            headers: {
              "unbxd-user-id": cookie.get("unbxd.userId"),
            },
          });

          // Update state with the response
          setUnbxdPdts(response.data.response.products);
          setNoOfFilteredPdtFromUnbxd(response.data.response.numberOfProducts);
          setPageSalesSize(response.data.response.products.length);
        } catch (error) {
          console.log(error);
          swal("Something went wrong, please try again later.");
        }
      })();

      return updatedFilters;
    });
  };

  useEffect(() => {
    if (data.appliedFilterFromUnbxd?.length > 0) {
      const validFilters = [];

      const validQueryParams = {};

      data.appliedFilterFromUnbxd.forEach((filter) => {
        const [key, value] = Object.entries(filter)[0];

        const unbxdKey = Object.keys(filterMapArr[0]).find(
          (unbxdKey) => filterMapArr[0][unbxdKey] === key
        );

        const facetValue = attributejson[key]?.options[value];

        if (unbxdKey && facetValue) {
          validFilters.push({
            facetName: unbxdKey,

            facetValue,
          });

          // Only keep valid ones for URL

          validQueryParams[key] = value;
        } else {
          console.warn("Removing invalid filter from URL:", { key, value });
        }
      });

      // Sync URL with only valid filters

      const currentPath = router.pathname;

      router.replace(
        {
          pathname: currentPath,

          query: validQueryParams,
        },

        undefined,

        { shallow: true }
      );

      setSelectedFilterFromUnbxd(validFilters);

      // Build Unbxd URL

      const unbxdUrl = new URL(
        `https://search.unbxd.io/5a4b9251b67027ff94d260e4ac6ac09e/ss-unbxd-aapac-prod-orientbell53741713874410/category`
      );

      // Add base params

      unbxdUrl.searchParams.set("p", 'u_categoryPathId:"/tiles"');

      unbxdUrl.searchParams.append("facet.multiselect", "true");

      unbxdUrl.searchParams.append("spellcheck", "true");

      unbxdUrl.searchParams.append("pagetype", "boolean");

      unbxdUrl.searchParams.append("start", "0");

      unbxdUrl.searchParams.append("rows", "25");

      unbxdUrl.searchParams.append("version", "V2");

      unbxdUrl.searchParams.append("fallback", "true");

      unbxdUrl.searchParams.append("viewType", "GRID");

      unbxdUrl.searchParams.append("facet.version", "V2");

      validFilters.forEach(({ facetName, facetValue }) => {
        unbxdUrl.searchParams.append("filter", `${facetName}:"${facetValue}"`);
      });

      // Make API call

      (async () => {
        try {
          const response = await axios.get(unbxdUrl.toString(), {
            headers: {
              "unbxd-user-id": cookie.get("unbxd.userId"),
            },
          });

          setUnbxdPdts(response.data.response.products);

          setNoOfFilteredPdtFromUnbxd(response.data.response.numberOfProducts);

          setPageSalesSize(response.data.response.products.length);
        } catch (error) {
          console.error("Error fetching Unbxd products:", error);

          // swal("Something went wrong, please try again later.");
        }
      })();
    } else {
      // No filters applied

      const unbxdUrl = `https://search.unbxd.io/5a4b9251b67027ff94d260e4ac6ac09e/ss-unbxd-aapac-prod-orientbell53741713874410/category?p-id=categoryPathId%3A%22${encodeURIComponent(
        router.asPath.split("?")[0]
      )}%22&facet.multiselect=true&spellcheck=true&pagetype=boolean&rows=25&start=0&version=V2&fallback=true&viewType=GRID&facet.version=V2`;

      (async () => {
        try {
          const response = await axios.get(unbxdUrl, {
            headers: {
              "unbxd-user-id": cookie.get("unbxd.userId"),
            },
          });

          setUnbxdPdts(response.data.response.products);

          setNoOfFilteredPdtFromUnbxd(response.data.response.numberOfProducts);

          setPageSalesSize(response.data.response.products.length);
        } catch (error) {
          console.error("Error fetching Unbxd products:", error);

          // swal("Something went wrong, please try again later.");
        }
      })();
    }
  }, [JSON.stringify(data.appliedFilterFromUnbxd)]);

  const getImageName = (facetName) => {
    switch (facetName) {
      case "tileType_uFilter":
        return "/type.png";
      case "tileSize_uFilter":
        return "/size.png";
      case "tileDesign_uFilter":
        return "/design.png";
      default:
        return "/default-filter.png";
    }
  };

  return (
    <>
      <Head>
        <meta charset="utf-8" />
        <meta name="title" content={dataSet.currentcategory.meta_title} />
        <title>{dataSet.currentcategory.meta_title}</title>
        <meta
          name="description"
          content={dataSet.currentcategory.meta_description}
        />
        <meta name="keywords" content={dataSet.currentcategory.meta_keywords} />
        <meta name="robots" content="INDEX,FOLLOW" />
        <meta name="format-detection" content="telephone=no" />
        <link
          rel="preconnect dns-prefetch"
          href="https://connect.facebook.net"
          crossorigin=""
        />
        <link
          rel="preconnect dns-prefetch"
          href="https://www.googletagmanager.com"
          crossorigin=""
        />
        <meta
          http-equiv="Accept-CH"
          content="viewport-width, width, device-memory, dpr, downlink, ect"
        />
        <meta name="pinterest-rich-pin" content="false" />
        <meta
          name="twitter:description"
          content={dataSet.currentcategory.meta_description}
        />
        <meta
          name="twitter:title"
          content={dataSet.currentcategory.meta_title}
        />
        <meta
          name="twitter:image"
          content={`${config.API_ENDPOINT}/media/img/logo.png`}
        />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="Orientbell" />
        <meta name="twitter:creator" content="Orientbell" />
        <meta
          property="og:url"
          content={`${config.HEADLESS_BASE_URL}/${router.query.category}`}
        />
        <meta
          property="og:description"
          content={dataSet.currentcategory.meta_description}
        />
        <meta
          property="og:title"
          content={dataSet.currentcategory.meta_title}
        />
        <meta
          property="og:image"
          content={`${config.API_ENDPOINT}/media/img/logo.png`}
        />
        {dataSet?.currentcategory?.schema && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: dataSet?.currentcategory?.schema.replace(
                /<script\s+type="application\/ld\+json">|<\/script>/g,
                ""
              ),
            }}
          />
        )}
        <meta
          property="og:image"
          content={`${config.API_ENDPOINT}/media/img/logo.png`}
        />
        <script
          type="text/javascript"
          src="https://cdn.roomvo.com/static/scripts/b2b/orientbell.js"
          defer=""
        ></script>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={webPageSchema()}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={breadsCrumbSchema()}
        />

        {/* Video Schema */}
        {data.videoSchema && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: data.videoSchema.replace(
                /<script\s+type="application\/ld\+json">|<\/script>/g,
                ""
              ),
            }}
          />
        )}
      </Head>
      <div className="page-wrapper category_listing_page">
        <div className="select-location-wrapper">
          <span>TO FIND PRICES IN YOUR CITY, ENTER YOUR PINCODE</span>
          <span className="select-wraper">
            <input
              value={pincode}
              onChange={(e) => handlePinCodeChangeInput(e)}
            ></input>{" "}
            {pincode && pincode?.length == 6 && (
              <span
                className="btn-close close-btn"
                onClick={() => {
                  setPinCode("");
                  cookie.remove("pincode");
                  localStorage.removeItem("pincode");
                  router.reload();
                }}
              ></span>
            )}
          </span>
        </div>
        {pincode?.length == 0 ||
          pincode == undefined ||
          (pincode?.length !== 6 && <span> Invalid PinCode</span>)}
        <section className="category-section">
          <div className="category-view">
            <div className="filter-by-mobile flex-class">
              <div className="locaton-custom">
                <div class="foot-icon-bx">
                  <img src="/Sort-By.svg" alt="sort" />
                </div>

                <select
                  className="form-control"
                  id="sel1"
                  value={sortValue}
                  onChange={(e) => handleSortChange(e)}
                >
                  <option value="">Sort By</option>
                  {dataSet.sort_fields.options.map((obj) => {
                    return (
                      <option value={obj.value} key={obj.value}>
                        {obj.label}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div
                className="filter-col"
                onClick={() => setmobileFilterOpen(!mobileFilterOpen)}
              >
                <div class="foot-icon-bx">
                  <img src="/filter.svg" alt="filter" />
                </div>

                <div className="sort-filter-col">Filter by</div>
              </div>
            </div>
            <div
              className={
                mobileFilterOpen ? "main-sidebar open-filter" : "main-sidebar"
              }
            >
              <div className="filter-heading-head">
                <h6>FILTERS</h6>{" "}
                <div className="filter-close-bx">
                  <img
                    src="/close-img.webp"
                    alt="close"
                    onClick={() => setmobileFilterOpen(false)}
                  />
                </div>
              </div>
              <div
                className="filter-overlay-bx"
                onClick={() => setmobileFilterOpen(false)}
              ></div>
              {ProdBySalesDate?.proCount > 0 ? (
                <div className="pro-filter-row">
                  <ul className="add_cls">
                    {filterTypeDataSet?.map((val, index) => {
                      const imageName = `/${val.toLowerCase()}.png`;
                      return (
                        <li
                          key={index}
                          className={
                            filteractive === index
                              ? "filter-active-cls"
                              : "filter-inactive-cat"
                          }
                          onClick={() => {
                            onFilterOnClickButton(val.toString());
                            setFilterActive(index);
                          }}
                        >
                          <div className="flt-type-img">
                            <img src={imageName} alt="" />
                          </div>
                          <h6>{val == "Floor" ? "Wall/Floor" : val} </h6>
                          <div className="filters-by open-filter">
                            {/* <div className="filter-close-bx"><img src="/close-img.webp" onClick={()=>setmobileFilterOpen(false)}/></div> */}
                            <ul
                              className={
                                selectedCode == "colors" ? "color-row" : ""
                              }
                            >
                              {selectedFilterData?.map((obj, index) => {
                                if (router.query[selectedCode] == obj.key) {
                                  return (
                                    <>
                                      {" "}
                                      <li
                                        style={{
                                          background: "#939393",
                                          color: "white",
                                        }}
                                        key={index}
                                        className={
                                          selectedCode == "colors"
                                            ? obj.value
                                            : ""
                                        }
                                      >
                                        {selectedCode == "colors" && (
                                          <spna className="color-option"></spna>
                                        )}
                                        {obj.value}
                                      </li>
                                      {index == 4 && (
                                        <div className="popular-sparater"></div>
                                      )}
                                    </>
                                  );
                                } else {
                                  return (
                                    <>
                                      <li
                                        key={index}
                                        className={
                                          selectedCode == "colors"
                                            ? obj.value
                                            : ""
                                        }
                                        onClick={() => {
                                          onFilterClick(obj.key, obj.value);
                                        }}
                                      >
                                        {selectedCode == "colors" && (
                                          <spna className="color-option"></spna>
                                        )}
                                        {obj.value}
                                      </li>
                                      {index == 4 && (
                                        <div className="popular-sparater"></div>
                                      )}
                                    </>
                                  );
                                }
                              })}
                            </ul>
                          </div>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              ) : (
                Array.isArray(data?.facetsUnbxd?.text?.list) &&
                data?.facetsUnbxd?.text?.list.length > 0 && (
                  <div className="pro-filter-row">
                    <ul className="add_cls tt">
                      {data?.facetsUnbxd?.text?.list.length > 1 &&
                        data?.facetsUnbxd?.text?.list.map(
                          (facet, facetIndex) => {
                            const imageName = getImageName(facet?.filterField);

                            return (
                              <li
                                key={facetIndex}
                                className={
                                  filteractive === facetIndex
                                    ? "filter-active-cls"
                                    : "filter-inactive-cat"
                                }
                                onClick={() => {
                                  setFilterActive(facetIndex);
                                }}
                              >
                                <div className="flt-type-img">
                                  <img
                                    src={imageName}
                                    alt={facet?.displayName || ""}
                                  />
                                </div>
                                <h6>{facet.displayName}</h6>

                                {filteractive === facetIndex && (
                                  <div className="filters-by open-filter">
                                    <ul>
                                      {facet.values
                                        .filter((_, index) => index % 2 === 0)
                                        .map((value, valueIndex) => (
                                          <li
                                            key={valueIndex}
                                            onClick={() =>
                                              filterResultsWithFacets(
                                                facet.filterField,
                                                value
                                              )
                                            }
                                            style={
                                              selectedFilterFromUnbxd.filter(
                                                (i) => i.facetValue === value
                                              ).length > 0
                                                ? {
                                                    background: "#939393",
                                                    color: "white",
                                                  }
                                                : {}
                                            }
                                          >
                                            {value}
                                          </li>
                                        ))}
                                    </ul>
                                  </div>
                                )}
                              </li>
                            );
                          }
                        )}
                    </ul>
                  </div>
                )
              )}
            </div>
            <div className="product-listing-wrap">
              <div className="bread-crumb-row">
                <ul>
                  <li itemprop="itemListElement">
                    <a href={config.HEADLESS_BASE_URL}>Home</a>
                  </li>
                  <li itemprop="itemListElement">
                    <a href="/tiles">Tiles</a>
                  </li>
                </ul>
              </div>
              <h1>{dataSet.currentcategory.name}</h1>
              {dataSet.currentcategory.description && (
                <div
                  className="category_accordion_data"
                  dangerouslySetInnerHTML={{
                    __html: shortDiscription,
                  }}
                />
              )}
              {ProdBySalesDate?.proCount >= 0 ? (
                <div className="amshopby-filter cc">
                  <ul style={{ display: "unset" }}>
                    {selectedFilters.length > 0 && (
                      <button
                        className="clear-all-btn"
                        onClick={() => removeAllFilters()}
                      >
                        Clear All Filters X
                      </button>
                    )}
                    {data.data.products.appliedFilters
                      .filter((cuu) => cuu?.attribute_code != "plocation")
                      .map((obj, index) => {
                        return (
                          <li key={index}>
                            {obj.label}
                            <button onClick={() => handleRemove(obj)}>X</button>
                          </li>
                        );
                      })}
                    {data.regionData && (
                      <li>
                        {data.regionData.state}
                        <button onClick={() => handleClick()}>X</button>
                      </li>
                    )}
                  </ul>
                </div>
              ) : (
                <div className="amshopby-filter vv">
                  <ul>
                    {selectedFilterFromUnbxd.length > 0 && (
                      <button
                        className="clear-all-btn"
                        onClick={() => removeUnbxdFilters()}
                      >
                        Clear All Filters X
                      </button>
                    )}
                    {selectedFilterFromUnbxd.map((filter, index) => (
                      <li key={index}>
                        {filter.facetValue}
                        <button onClick={() => handleRemoveUnbxdFilter(filter)}>
                          X
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
              <div className="category-sorting">
                <div className="tilecountis-bx">
                  <ul>
                    <li>
                      <button
                        onClick={() => {
                          handleLayOutclass("one");
                        }}
                      >
                        <i className="fa fa-th" />
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => {
                          handleLayOutclass("two");
                        }}
                      >
                        <i className="fa fa-th-large"></i>
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => {
                          handleLayOutclass("three");
                        }}
                      >
                        <i className="fa fa-bars"></i>
                      </button>
                    </li>
                  </ul>
                  {ProdBySalesDate?.proCount > 0 ? (
                    <p>
                      Items 1-{ProdBySalesDate.data.length} of{" "}
                      {ProdBySalesDate?.proCount}
                    </p>
                  ) : (
                    !pincode && (
                      <p className="xxx">
                        {/* Items 1-{dataSet.items.length} of {dataSet.total_count} */}
                        {UnbxdPdts?.length > 0
                          ? `Items 1-${
                              UnbxdPdts.length <
                              data.UnbxdResponse.numberOfProducts
                                ? UnbxdPdts.length
                                : data.UnbxdResponse.numberOfProducts
                            } of ${
                              noOfFilteredPdtFromUnbxd ||
                              data.UnbxdResponse.numberOfProducts
                            }`
                          : "Items 0 of 0"}
                      </p>
                    )
                  )}
                </div>
                {/* <div className="category-switch">
                  <span>Tiles</span>
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={isAmbience}
                      onChange={(e) => handleAmbience(e)}
                    />
                    <span className="slider round"></span>
                  </label>
                  <span>Room</span>
                </div> */}

                {/* //Commented before taking unbxd live. need to fix it enitrely */}
                {/* <div className="sorts-bx">
                  <div className="form-group">
                    <label for="sel1">Sort By</label>
                    <select
                      className="form-control"
                      id="sel1"
                      value={sortValue}
                      onChange={(e) => handleSortChange(e)}
                    >
                      {dataSet.sort_fields.options.map((obj) => {
                        return (
                          <option value={obj.value} key={obj.value}>
                            {obj.label}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div> */}
              </div>
              {loading ? (
                <Loader />
              ) : (
                <>
                  <div className={pageLayoutClass}>
                    {ProdBySalesDate?.data?.length > 0
                      ? ProdBySalesDate.data.map((product, index) => {
                          return (
                            <>
                              {(index == 3 || index == 27 || index == 51) && (
                                <div className="product-listing-col">
                                  <img
                                    src="/catagoryLeadImg.jpeg"
                                    onClick={() => setGetInTouch(true)}
                                    className="categoryBanner"
                                  ></img>
                                </div>
                              )}
                              {(index == 11 || index == 35 || index == 59) && (
                                <div className="product-listing-col">
                                  <img
                                    src="/OBL.jpg"
                                    onClick={() => setGetInTouch(true)}
                                    alt="image"
                                    className="categoryBanner"
                                  ></img>
                                </div>
                              )}
                              <ProductCard
                                isAmbience={isAmbience}
                                product={product}
                                category={dataSet.currentcategory.name}
                                addProductToComapre={addProductToComapre}
                              />
                            </>
                          );
                        })
                      : UnbxdPdts?.map((product, index) => {
                          return (
                            <>
                              {(index == 3 || index == 27 || index == 51) && (
                                <div className="product-listing-col">
                                  <img
                                    src="/catagoryLeadImg.jpeg"
                                    onClick={() => setGetInTouch(true)}
                                    className="categoryBanner"
                                  ></img>
                                </div>
                              )}
                              {(index == 11 || index == 35 || index == 59) && (
                                <div className="product-listing-col">
                                  <img
                                    src="/OBL.jpg"
                                    onClick={() => setGetInTouch(true)}
                                    alt="image"
                                    className="categoryBanner"
                                  ></img>
                                </div>
                              )}
                              <UnbxdProductCard
                                isAmbience={isAmbience}
                                product={product}
                                category={dataSet.currentcategory.name}
                                addProductToComapre={addProductToComapre}
                              />
                            </>
                          );
                        })}
                  </div>
                </>
              )}
              {loading2 ? (
                <Loader />
              ) : (
                <div className="load-more-product">
                  {ProdBySalesDate?.proCount > 0 &&
                  ProdBySalesDate?.proCount != ProdBySalesDate.data.length ? (
                    <button
                      onClick={() => {
                        loadMoreSalesData();
                      }}
                    >
                      Load More From {ProdBySalesDate?.proCount - PageSalesSize}
                    </button>
                  ) : (
                    ProdBySalesDate?.length === 0 &&
                    UnbxdPdts?.length > 0 &&
                    UnbxdPdts?.length <
                      (noOfFilteredPdtFromUnbxd ||
                        data.UnbxdResponse.numberOfProducts) && (
                      <button
                        className="bt"
                        onClick={() => {
                          pageSizeUnbxd += 25;

                          loadMoreSalesData2(); // Make sure this function updates noOfFilteredPdtFromUnbxd correctly

                          // After loading all products, update the total count to prevent incorrect numbers
                          if (UnbxdPdts.length === noOfFilteredPdtFromUnbxd) {
                            noOfFilteredPdtFromUnbxd = UnbxdPdts.length;
                          }
                        }}
                      >
                        Load More
                      </button>
                    )
                  )}
                </div>
              )}
              <div
                className="category_accordion_data"
                dangerouslySetInnerHTML={{
                  __html: dataSet.currentcategory.dynamic_content.replace(
                    /<p>\s*(&nbsp;)?\s*<\/p>/g,
                    ""
                  ),
                }}
              />
              <div className="tru_btn_new">
                <a className="btn btn-primary" href="/trialook">
                  Trialook
                </a>
              </div>
            </div>
          </div>
          <div className="tile-related-blog-section">
            <div className="container">
              {relatedBlogData?.length > 0 && (
                <div className="tile-related-blog">
                  <h2 className="title">Related Blogs</h2>
                  <div className="listing-Wrap">
                    {relatedBlogData?.map((obj, index) => {
                      return (
                        <div className="listing-col" key={index}>
                          <div className="listingImg">
                            <a href={obj.permalink} rel="nofollow">
                              <img
                                src={obj.image}
                                loading="lazy"
                                alt="Marble Tiles Vs Marble Slab: What is Better for Your Home?"
                              />
                            </a>
                          </div>
                          <div className="listing_blog_data">
                            <div className="listingDate">{obj.date}</div>
                            <div className="listingHead">
                              <a href={obj.permalink} rel="nofollow">
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: obj.title,
                                  }}
                                />
                              </a>
                            </div>
                          </div>
                          <div className="listingText">
                            <p>
                              {" "}
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: obj.content.slice(0, -11),
                                }}
                              />
                            </p>
                            <div className="listingButton">
                              <a href={obj.permalink} rel="nofollow">
                                Read More
                              </a>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>
      </div>
      <div
        className="modal show pincode-popup-bx"
        style={{ display: "block", position: "initial" }}
      >
        <Modal show={modalIsOpen} className="pincode-popup-bx">
          <Modal.Dialog>
            <Modal.Header>
              <Modal.Title>Enter your Pincode for best prices</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <form>
                <input
                  value={pincode}
                  onChange={(e) => handlePinCodeChange(e)}
                />
              </form>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="primary" onClick={() => handlePinSave()}>
                Submit
              </Button>
              <Button
                variant="secondary"
                onClick={() => {
                  setModalIsOpen(false);
                  localStorage.setItem("pincodeSkip", true);
                }}
              >
                Don&apos;t show again
              </Button>
            </Modal.Footer>
          </Modal.Dialog>
        </Modal>

        <Modal
          show={getInTouch}
          className="pincode-popup-bx expert_assistance_modal"
          onHide={() => setGetInTouch(false)}
        >
          <Modal.Dialog>
            <Modal.Header closeButton>
              <Modal.Title>Get Tile Expert Assistance</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  submitGetInTouch();
                }}
              >
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Name*"
                    onChange={(e) => {
                      setTouch({
                        ...touch,
                        name: e.target.value,
                      });
                    }}
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicPassword">
                  <Form.Label>Mobile</Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="Mobile Number*"
                    onChange={(e) => {
                      setTouch({
                        ...touch,
                        number: e.target.value,
                      });
                    }}
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicPassword">
                  <Form.Label>Pincode</Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="Pincode"
                    onChange={(e) => {
                      setTouch({
                        ...touch,
                        pincode: e.target.value,
                      });
                    }}
                  />
                </Form.Group>
                {touch.error && (
                  <p className="error text-danger">{touch.error}</p>
                )}

                <Button
                  variant="primary"
                  type="submit"
                  disabled={touch.loading}
                  style={{ width: "100%" }}
                >
                  {touch.loading ? "Submitting" : "Submit"}
                </Button>
              </Form>
            </Modal.Body>
            {/* <Modal.Footer>
              <Button variant="primary" onClick={() => handlePinSave()}>
                Submit
              </Button>
            </Modal.Footer> */}
          </Modal.Dialog>
        </Modal>
      </div>
    </>
  );
};

export default Category;
